export default __webpack_public_path__ + "static/media/vozik_hover.3ef1091d.png";